import Box from "@mui/material/Box"
import React, { useEffect } from "react"

import QpienLogo from "@assets/qpien_logo"
import LanguageSelector from "@components/language_selector"

import { useLocation } from "react-router-dom"
import styles from "./styles"
import PublicCarousel from "./sub_components/public_carousel"

export default function PublicLayout(props: {
  children: React.ReactNode | React.ReactNode[]
}) {
  return (
    <Box {...props} sx={styles.container}>
      <UrlChecker />
      <Box sx={styles.contextContainer}>
        <Box sx={styles.headerContainer}>
          <QpienLogo />
          <LanguageSelector />
        </Box>
        <Box sx={styles.outletContainer}>{props.children}</Box>
      </Box>
      <Box sx={styles.carouselContainer}>
        <PublicCarousel />
      </Box>
    </Box>
  )
}

function UrlChecker() {
  const location = useLocation()
  useEffect(() => {
    if (!location.pathname.startsWith("/public")) {
      return
    }

    const jwt = localStorage.getItem("authToken")
    if (!jwt || jwt.trim().length < 2) {
      return
    }
    window.location.replace("/dashboard")
  }, [location])
  return <></>
}
